import React from "react";
import { Outlet } from "react-router-dom";
import "./ReleaseNotes.css";

const ReleaseNotesLayout = () => {
  return (
    <div className="release-notes-container">
      <div className="notes-container">
        <div className="container-fluid p-3">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default ReleaseNotesLayout;
